import { useEffect, useState, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider.js';
import { listConfig, type ConfigItem } from '../../api/configApi.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

export function ConfigListPage(): ReactNode {
  const { token } = useAuth();
  const { t } = useTranslation();
  const [rows, setRows] = useState<readonly ConfigItem[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    listConfig(token)
      .then((r) => {
        if (alive) setRows(r);
      })
      .catch((e) => {
        if (alive) setError((e as Error).message);
      });
    return () => {
      alive = false;
    };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('common.loading')}</p>;
  return (
    <main aria-label="config-list">
      <h1>{t('config.list.title')}</h1>
      <table aria-label="config-table">
        <thead>
          <tr>
            <th>{t('config.list.col.parameter')}</th>
            <th>{t('config.list.col.description')}</th>
            <th>{t('config.list.col.type')}</th>
            <th>{t('config.list.col.value')}</th>
            <th>{t('config.list.col.override')}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.parameterCode} data-testid={`row-${r.parameterCode}`}>
              <td>
                <Link
                  to={`/admin/config/${encodeURIComponent(r.parameterCode)}`}
                  data-testid={`edit-link-${r.parameterCode}`}
                >
                  {r.parameterCode}
                </Link>
              </td>
              <td>{r.description}</td>
              <td>{r.valueType}</td>
              <td>{r.isSecret ? '••••••••' : r.value ?? '—'}</td>
              <td>{r.hasOverride ? t('common.yes') : t('common.no')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
